import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import { logout } from '../actions/auth.js';
import store from '../store.js';
import AuthHeader from "../services/auth.header.js";

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  const status = error && error.response ? error.response.status : null;
  if (status === 401 || status === 403) {
    console.log("401 error --------------------------------------");
  // Dispatch the logout action to clear the user's session
    store.dispatch(logout());
  }
  return Promise.reject(error);
});

export const getUsersForSubsite = createAsyncThunk('user/getUsersForSubsite', async (params) => {
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/users?range=" + JSON.stringify(params[0]) + "&filter=" + params[1] + "&search=" + params[2], { headers: AuthHeader.authHeader()});
        return response.data;
    } catch (error) {
        //console.log("ERROR OBJ", error);
        //if(error.response.status === 401) {

           // window.location.href = "/login";
        //}
        //return error;
    }    
  });

  export const getBulkUsersForSubsite = createAsyncThunk('user/getBulkUsersForSubsite', async (params = {}) => {
    try {
        const page = params.page || (Array.isArray(params.range) ? params.range[0] : 1) || 1;
        const perPage = params.perPage || (Array.isArray(params.range) ? params.range[1] : 50) || 50;
        const search = params.search || '';
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/bulkusers", {
          headers: AuthHeader.authHeader(),
          params: {
            range: JSON.stringify([page, perPage]),
            ...(search ? { search } : {})
          },
          timeout: 60000
        });
        return response.data;
    } catch (error) {
        throw error;
    }
  });

  export const getUser = createAsyncThunk('user/getUser', async (userId) => {
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/users/" + userId, { headers: AuthHeader.authHeader()});
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const reloadUser = createAsyncThunk('user/reloadUser', async (userId) => {
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/users/" + userId, { headers: AuthHeader.authHeader()});
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const updatePassword = createAsyncThunk('user/updatePassword', async (passwords) => {
    try {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/user/password", 
          passwords,
          { headers: AuthHeader.authHeader() }
        );
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const updateAddress = createAsyncThunk('user/updateAddress', async (newAddress) => {
    try {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/user/address", 
          newAddress,
          { headers: AuthHeader.authHeader() }
        );
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const updateBalance = createAsyncThunk('user/updateBalance', async (balance) => {
    try {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/user/balance", 
          balance,
          { headers: AuthHeader.authHeader() }
        );
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const createUser = createAsyncThunk('user/', async (newUser, {rejectWithValue}) => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + "/user/create", 
          newUser,
          { headers: AuthHeader.authHeader() }
        );
        console.log("RESPONSE", response);
        return response.data;
    } catch (error) {
      console.log("ERROR RESPONSE", error);
      return rejectWithValue(error.response.data);
    }    
  });


  export const getXlsUserReport = createAsyncThunk('user/getXlsUserReport', async () => {
    console.log("Getting XLS User Report");
    const response = await axios.get(process.env.REACT_APP_API_URL +  "/admin/userlist/xls", { headers: {
          ...AuthHeader.authHeader(),
          'Content-Disposition': "attachment; filename=./user_report.xlsx",
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
        responseType: 'arraybuffer',
        }
    );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'user_report.xlsx');
        document.body.appendChild(link);
        link.click();
  });

  export const bulkUpload = createAsyncThunk('user/bulkUpload', async (selectedFile) => {
    console.log("Bulk Upload");
    const data = new FormData();
    data.append('file', selectedFile, selectedFile.name);
    const response = await axios.post(process.env.REACT_APP_API_URL +  "/admin/user/upload", data,
      { headers: AuthHeader.authHeader() });
    console.log("RESPONSE", response);
    return response.data;
  });


  export const allUsers = state => state.users.users;
  export const currentUser = state => state.users.currentUser;
  export const user = state => state.users.user;
  export const userTotalCount = state => state.users.userTotalCount;
  export const unregisteredCount = state => state.users.unregisteredCount;
  export const errorMessage = state => state.users.error;
  export const createStatus = state => state.users.createStatus;
  export const bulkStatus = state => state.users.bulkStatus;
  export const bulkResults = state => state.users.bulkResults;
  export const status = state => state.users.status;
  

  const initialState = {
    users: [],
    userTotalCount: 0,
    unregisteredCount: 0,
    currentUser: {},
    user: {},
    status: 'idle',
    passwordStatus: 'idle',
    createStatus: 'idle',
    bulkStatus: 'idle',
    loadUserStatus: 'idle',
    bulkResults: [],
    error: null
  };

  const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
          .addCase(getUsersForSubsite.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getUsersForSubsite.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.users = action.payload.data;
            state.userTotalCount = action.payload.count;
            state.unregisteredCount = action.payload.unregistered;
          })
          .addCase(getUsersForSubsite.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
            console.log("ERROR", action.error);
          })
          .addCase(getBulkUsersForSubsite.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getBulkUsersForSubsite.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.users = action.payload.data;
            state.userTotalCount = action.payload.count;
          })
          .addCase(getBulkUsersForSubsite.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
            console.log("ERROR", action.error);
          })
          .addCase(getUser.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getUser.fulfilled, (state, action) => {
            console.log("ACTION", action);
            state.status = 'succeeded';
            console.log("USER IN REDUX", action.payload);
            state.user = action.payload;
          })
          .addCase(getUser.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
          .addCase(updatePassword.pending, (state, action) => {
            state.passwordStatus = 'loading'
          })
          .addCase(updatePassword.fulfilled, (state, action) => {
            state.passwordStatus = 'succeeded'
            state.currentUser = action.payload;
          })
          .addCase(updatePassword.rejected, (state, action) => {
            state.passwordStatus = 'failed'
            state.error = action.error.message
          })
          .addCase(updateBalance.pending, (state, action) => {
            state.passwordStatus = 'loading'
          })
          .addCase(updateBalance.fulfilled, (state, action) => {
            //state.passwordStatus = 'succeeded'
            state.user = action.payload;
          })
          .addCase(updateBalance.rejected, (state, action) => {
            state.passwordStatus = 'failed'
            state.error = action.error.message
          })
          .addCase(createUser.pending, (state, action) => {
            console.log("PENDING", action);
            state.createStatus = 'loading';
            state.error = "";
          })
          .addCase(createUser.fulfilled, (state, action) => {
            console.log("SUCCESS", action);
            state.createStatus = 'succeeded';
            state.users.push(action.payload);
            state.error = "";
          })
          .addCase(createUser.rejected, (state, action) => {
            console.log("ACTION", action);
            state.createStatus = 'failed';
            state.error = action.payload.message;
          })
          .addCase(bulkUpload.pending, (state, action) => {
            console.log("PENDING", action);
            state.bulkStatus = 'loading';
            state.bulkResults = [];
          })
          .addCase(bulkUpload.fulfilled, (state, action) => {
            console.log("SUCCESS", action);
            state.bulkStatus = 'succeeded';
            state.bulkResults = action.payload.errors;
          })
          .addCase(bulkUpload.rejected, (state, action) => {
            console.log("ACTION", action);
            state.bulkStatus = 'failed';
            state.bulkResults = [];
          })
      }
  });
  
  export default userSlice.reducer;




